module.exports = __webpack_public_path__ + "static/media/logo_border_star_00001.740d5cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/border-star/logo_border_star_00001.png
// module id = 414
// module chunks = 0